import { ArticleFields } from 'src/shared/ArticleBase.types';
import {
  AnchorTargetParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type C51BlogDetailsProps = RenderingProps<ArticleFields, C51BlogDetailsParams>;

export type C51BlogDetailsParams = AnchorTargetParams & TranslationOptionsParams;
